<template>
  <v-btn
    v-if="item.INVDETACCESS"
    depressed
    block
    style="height: 32px !important"
    color="chip"
    :loading="loading"
    class="text-capitalize ml-2"
    @click="clickFn()"
  >
    <span>İndir</span>
  </v-btn>
</template>

<script>
import { ref } from "vue-demi";

// Pinia
import { useDocumentStore } from "./_store";

export default {
  props: ["item"],
  setup(props) {
    // Initial
    const store = useDocumentStore();

    const loading = ref(false);

    const clickFn = async () => {
      loading.value = true;

      await store.documentDownload(props.item.DOCNUM, props.item.DOCTYPE);
      loading.value = false;
    };
    return {
      loading,
      clickFn,
    };
  },
};
</script>

<style></style>
